import Tone from 'tone';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Effects from 'effects/Effects.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';

class Distortion extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Distortion", () => new Tone.Distortion(0.4), sequencerEngine);
        this.effectNode.oversampling = '4x';
        this.distortionParameter = new AbstractAudioParamParameter(
            'Distortion', this.effectNode, (o, x) => o.distortion = x, {
                min: 0,
                max: 1,
                unit: '%',
                defaultValue: 0.1
            });
        this.registerParameter(this.distortionParameter);
        this.updateInitialValues();
    }

    getJson() {
        let json = super.getJson();
        json.distortion = this.effectNode.distortion;
        json.enabled = this.enabledParameter.get();
        json.wet = this.effectNode.wet.value;
        json.name = this.name;

        if (this.distortionParameter.isConnectedToAnyModulator() ||
            Object.keys(this.distortionParameter.patternToValue).length > 0) {
            json.distortionParameter = this.distortionParameter.getJson();
        }
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.distortionParameter, json.distortion, bulk);
        if (json.enabled) {
            this.enable(true);
        }
        this.setValue(json.value);

        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'distortionParameter', this.distortionParameter, isCopy)
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new Distortion(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default Distortion;
